import { LayoutGridIcon, ListIcon } from '@/icons';
import { Button, Flex } from 'antd';
import { cn } from '../lib/cn';

type Props = {
  mode: string;
  disabled?: 'grid' | 'list';
  setMode: (mode: string) => void;
};

const ViewToggler = ({ mode, setMode, disabled }: Props) => {
  return (
    <Flex gap={9} align="center">
      <span className="text-white text-base font-medium">View:</span>
      <Flex gap={4}>
        <Button
          onClick={() => setMode('grid')}
          disabled={disabled === 'grid'}
          className={cn(
            '!bg-transparent !border-none !shadow-none hover:!bg-theme-slate-800 hover:!text-white',
            'disabled:!opacity-50 disabled:hover:!bg-transparent disabled:!text-white',
            mode === 'grid' && '!bg-theme-slate-800',
          )}
          icon={<LayoutGridIcon className="size-5" />}
          classNames={{ icon: 'flex items-center justify-center' }}
        />
        <Button
          onClick={() => setMode('list')}
          disabled={disabled === 'list'}
          className={cn(
            '!bg-transparent !border-none !shadow-none hover:!bg-theme-slate-800 hover:!text-white',
            'disabled:!opacity-50 disabled:hover:!bg-transparent disabled:!text-white',
            mode === 'list' && '!bg-theme-slate-800',
          )}
          icon={<ListIcon className="size-5" />}
          classNames={{ icon: 'flex items-center justify-center' }}
        />
      </Flex>
    </Flex>
  );
};

export default ViewToggler;
